export enum ErrorType {
    Forbidden = 'forbidden',
    NotFound = 'not-found',
    ServerError = 'server-error',
    OrderCashSales = 'order-cash-sales',
    Language = 'language',
    Features = 'features',
    FailedRequest = 'failed-request'
}
